module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/157-republic-of-the-congo-403352c81f144e666d75fc5ded904779.svg";